import { render } from "./CircleSvg.vue?vue&type=template&id=6cab1575&scoped=true"
const script = {}

import "./CircleSvg.vue?vue&type=style&index=0&id=6cab1575&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cab1575"]])

export default __exports__